import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=0ae101a8&scoped=true&"
import script from "./productDetails.vue?vue&type=script&lang=js&"
export * from "./productDetails.vue?vue&type=script&lang=js&"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=0ae101a8&prod&lang=less&scoped=true&"
import style1 from "./productDetails.vue?vue&type=style&index=1&id=0ae101a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae101a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PicZoom: require('/app/components/picZoom/picZoom.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ProductLabel: require('/app/components/productLabel.vue').default})
